import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import authentication from '../utils/auth/react-azure-adb2c';
import * as actions from '../actions';

const withAuthentication = WrappedComponent => props => {
    const dispatch = useDispatch();
    const accessToken = useSelector(state => state.applicationUser.accessToken);
    const accessTokenFromAuthentication = authentication.getAccessToken();

    const loginSucceededAction = useCallback(
        payload => {
            dispatch(actions.loginSucceeded(payload));
        },
        [dispatch],
    );

    const updateTokenAction = useCallback(
        payload => {
            dispatch(actions.updateToken(payload));
        },
        [dispatch],
    );

    useEffect(() => {
        if (!accessToken) {
            loginSucceededAction({ accessTokenFromAuthentication });
        } else {
            updateTokenAction({ accessTokenFromAuthentication });
        }
    }, [accessTokenFromAuthentication]);

    return <WrappedComponent {...props} />;
};

export default withAuthentication;
